import React from 'react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 80;
      const targetPosition = element.offsetTop - navbarHeight - 20;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-hector-dark-grey text-white py-12">
      <div className="container mx-auto px-6">
    
        
        <div className="text-center text-sm text-gray-400">
          <p>&copy; 2025 Hector AI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
